import { useEffect, useState } from 'react';
import './App.css';
import GoToTopButton from './components/Home/GoToTopButton';
import Home from './components/Home/Home';
import { ToastContainer } from "react-toastify";
import Preloader from './Loader';
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
    <Preloader load={load} />
    <div className="App" id={load ? "no-scroll" : "scroll"}>
      <ToastContainer />
      <Home  />
      <GoToTopButton />
    </div>
    </>
  );
}

export default App;
